import React from "react";
import { TFunction } from "i18next";
import { useDispatch } from "react-redux";

import { AppDispatch } from "../../../../../../redux/store";
import {
    setGlobalDataIsUpdated,
    setIsActionsClicked,
    setIsEdited,
} from "../../../../../../redux/slices/fidelitySlice";
import { useFidelityNavigationGuard } from "../../../FidelityNavigationGuardContext";

type Props = {
    isEdited: boolean;
    isActionsClicked: boolean;
    isFidelityArchived: boolean;
    setIsFidelityArchived: (v: boolean) => void;
    setIsAddFidelityClicked: (v: boolean) => void;
    setDataIsUpdated: (v: boolean) => void;
    t: TFunction;
};

export default function TabSwitchItems({
    isEdited,
    isActionsClicked,
    isFidelityArchived,
    setIsFidelityArchived,
    setIsAddFidelityClicked,
    setDataIsUpdated,
    t,
}: Props) {
    const dispatch = useDispatch<AppDispatch>();
    const { setOnConfirm } = useFidelityNavigationGuard();

    const handleEnabledClick = () => {
        if (isFidelityArchived) {
            setDataIsUpdated(true);
            dispatch(setGlobalDataIsUpdated(true));
        }
        setIsFidelityArchived(false);
    };

    const handleArchivedClick = () => {
        if (isEdited) {
            dispatch(setIsActionsClicked(!isActionsClicked));
            setOnConfirm(() => {
                dispatch(setIsEdited(false));
                setIsFidelityArchived(true);
                setIsAddFidelityClicked(false);
                setDataIsUpdated(true);
                dispatch(setGlobalDataIsUpdated(true));
            });
        } else {
            if (!isFidelityArchived) {
                setDataIsUpdated(true);
                dispatch(setGlobalDataIsUpdated(true));
            }
            setIsFidelityArchived(true);
            setIsAddFidelityClicked(false);
        }
    };

    return (
        <React.Fragment>
            <div
                data-testid="fidelity-franchise-tab-enabled"
                className="dropdown-item pl-1"
                style={{ cursor: "pointer" }}
                onClick={handleEnabledClick}
            >
                <span className="ml-2 cmn_btn_FRlistActivated">
                    {t("Fidelity Enabled(s)")}
                </span>
            </div>
            <div
                data-testid="fidelity-franchise-tab-archived"
                className="dropdown-item pl-1"
                style={{ cursor: "pointer" }}
                onClick={handleArchivedClick}
            >
                <span className="ml-2 cmn_btn_FRlistArchived">
                    {t("Archived fidelity(s)")}
                </span>
            </div>
        </React.Fragment>
    );
}
